<template>
     <div>
         <button><i class="fa fa-bars"></i></button>


          <div class="page-sidebar">
            
              <div class="location-details">              
                  <div class="zip-code">
                    <label><i class="fas fa-search"></i>搜尋</label>
                    <input  @keydown="filter()" v-model="model.keyword" type="text" placeholder="關鍵字">
                  </div> <!-- end .zip-code -->              
              </div>
            <br>
            <div class="view-more">
                  <a class="btn btn-default text-center" href="javascript:void(0)"  @click="reset"><i class="fa fa-redo"></i>清除</a>
            </div>            
            <!-- Category accordion -->
            <div id="categories">
              <div class="accordion">
                <ul class="nav nav-tabs accordion-tab" role="tablist">
                  <li class="active">
                    <a href="#" role="tab" data-toggle="tab"><i class="fas fa-map-marker-alt"></i>地區</a>
     <div class="row" style="margin-bottom:30px;">                                                      
                          <div>   
                            <strong>-- 港島區域 --</strong>
                            <br><br>
                            <input  @change="filter()"  v-model="model.districts['中西區']"  id="1" type="checkbox" >
                            <label class="checkbox-label"  for="d1" >中西區</label>
                            <br>
                            <input  @change="filter()"  v-model="model.districts['香港東區']"  id="1" type="checkbox" >
                            <label class="checkbox-label"  for="d1" >香港東區</label>
                            <br>   

                            <input  @change="filter()"  v-model="model.districts['離島區']"  id="1" type="checkbox" >
                            <label class="checkbox-label"  for="d1" >離島區</label>
                            <br>   
                            <input  @change="filter()"  v-model="model.districts['香港南區']"  id="1" type="checkbox" >
                            <label class="checkbox-label"  for="d1" >香港南區</label>
                            <br>   
                            <input  @change="filter()"  v-model="model.districts['灣仔區']"  id="1" type="checkbox" >
                            <label class="checkbox-label"  for="d1" >灣仔區</label>
                            <br>   <br>
                            <strong>-- 九龍區域 --</strong>
                            <br><br>
                            <input  @change="filter()"  v-model="model.districts['九龍城區']"  id="1" type="checkbox" >
                            <label class="checkbox-label"  for="d1" >九龍城區</label>
                            <br>   
                            <input  @change="filter()"  v-model="model.districts['觀塘區']"  id="1" type="checkbox" >
                            <label class="checkbox-label"  for="d1" >觀塘區</label>
                            <br>   
                            <input  @change="filter()"  v-model="model.districts['西貢區']"  id="1" type="checkbox" >
                            <label class="checkbox-label"  for="d1" >西貢區</label>
                            <br>   
                            <input  @change="filter()"  v-model="model.districts['深水埗區']"  id="1" type="checkbox" >
                            <label class="checkbox-label"  for="d1" >深水埗區</label>
                            <br>   
                            <input  @change="filter()"  v-model="model.districts['黃大仙區']"  id="1" type="checkbox" >
                            <label class="checkbox-label"  for="d1" >黃大仙區</label>
                            <br>      
                            <input  @change="filter()"  v-model="model.districts['油尖旺區']"  id="1" type="checkbox" >
                            <label class="checkbox-label"  for="d1" >油尖旺區</label>
                            <br>      <br>                          
                            <strong>-- 新界西區域 --</strong>
                            <br><br>
                            <input  @change="filter()"  v-model="model.districts['葵青區']"  id="1" type="checkbox" >
                            <label class="checkbox-label"  for="d1" >葵青區</label>
                            <br>   
                            <input  @change="filter()"  v-model="model.districts['荃灣區']"  id="1" type="checkbox" >
                            <label class="checkbox-label"  for="d1" >荃灣區</label>
                            <br>   
                            <input  @change="filter()"  v-model="model.districts['屯門區']"  id="1" type="checkbox" >
                            <label class="checkbox-label"  for="d1" >屯門區</label>
                            <br>   
                            <input  @change="filter()"  v-model="model.districts['元朗區']"  id="1" type="checkbox" >
                            <label class="checkbox-label"  for="d1" >元朗區</label>
                            <br>      <br>                        
                            <strong>-- 新界東區域 --</strong>
                            <br><br>
                            <input  @change="filter()"  v-model="model.districts['北區']"  id="1" type="checkbox" >
                            <label class="checkbox-label"  for="d1" >北區</label>
                            <br>      
                            <input  @change="filter()"  v-model="model.districts['沙田區']"  id="1" type="checkbox" >
                            <label class="checkbox-label"  for="d1" >沙田區</label>
                            <br>             
                            <input  @change="filter()"  v-model="model.districts['大埔區']"  id="1" type="checkbox" >
                            <label class="checkbox-label"  for="d1" >大埔區</label>
                            <br>                                  
                                                                                                                                                                                                                                                                                                                                                                                                             
                          </div>
                    </div>
                  </li>
                    <li class="">
                      <a href="#" role="tab" data-toggle="tab"><i class="fas fa-list-alt"></i>服務種類</a>

                    <div class="row" style="margin-bottom:30px;">    
                          <template v-for="(f, index) in serveTypes" >
                                    
                              <div>
                                <input @change="filter()" v-model="model.serveTypes[f]"  :id="`fin${index}`" type="checkbox"> 
                              <label class="checkbox-label"  :for="`fin${index}`" >{{f}}</label>
                              <br>
                              </div>
                          </template>       
                    </div>
                  </li>
                  <li class="">
                    <a href="#" role="tab" data-toggle="tab"><i class="far fa-star"></i>宗教</a>

      <div class="row" style="margin-bottom:30px;">    
                          <div> <input @change="filter()" v-model="model.religious['佛教']"  type="checkbox" > 
                            <label class="checkbox-label" >佛教</label><br>            
                          </div>

                          <div> <input @change="filter()" v-model="model.religious['道教']"  type="checkbox" > 
                            <label class="checkbox-label" >道教</label><br>            
                          </div>

                          <div> <input @change="filter()" v-model="model.religious['孔教']"  type="checkbox" > 
                            <label class="checkbox-label" >孔教</label><br>            
                          </div>

                          <div> <input @change="filter()" v-model="model.religious['天主教']"  type="checkbox" > 
                            <label class="checkbox-label" >天主教</label><br>            
                          </div>

                          <div> <input @change="filter()" v-model="model.religious['基督教']"  type="checkbox" > 
                            <label class="checkbox-label" >基督教</label><br>            
                          </div>

                          <div> <input @change="filter()" v-model="model.religious['伊斯蘭教']"  type="checkbox" > 
                            <label class="checkbox-label" >伊斯蘭教</label><br>            
                          </div>

                          <div> <input @change="filter()" v-model="model.religious['儒釋道三教']"  type="checkbox" > 
                            <label class="checkbox-label" >儒釋道三教</label><br>            
                          </div>
                          <div> <input @change="filter()" v-model="model.religious['儒、釋、道']"  type="checkbox" > 
                            <label class="checkbox-label" >儒、釋、道</label><br>            
                          </div>

                          <div> <input @change="filter()" v-model="model.religious['無宗教背景']"  type="checkbox" > 
                            <label class="checkbox-label" >無宗教背景</label><br>            
                          </div>                          
                    
                    </div>
                  </li>				                                  
                  <li class="">
                    <a href="#"><i class="fas fa-venus-mars"></i>性別</a>
                    <div class="row" style="margin-bottom:30px;"> 
                        <template v-for="(d, index) in genders">                                                                        
                                <input @change="filter()" v-model="model.genders[d]"  :id="`gender${index}`" type="checkbox" > 
                                <label class="checkbox-label"  :for="`gender${index}`" >{{d}}</label><br>                              
                        </template>  
                    </div>
                  </li>                
                </ul>
              </div> <!-- end .accordion -->
            </div> <!-- end #categories -->
      
          </div> <!-- end .page-sidebar -->
        </div> <!-- end grid layout-->
</template>
<script>
export default {
  props: {
    districts: "",
    serveTypes: "",
    currentServeType: "",
    genders: "",
    religious: "",   
  },
   data: function() {
    return {            
      model: {
        districts: [],
        serveTypes: [],
        religious: [],
        genders: [],
        keyword: ""
      }
    };
  },
  created() {
    if (this.$props.districts === null) {
      this.model.districts = {};
    } else if (this.$props.districts != '') {
      const districts = this.$props.districts.split(',');
      districts.forEach(district => {
        this.$set(this.model.districts, district, true);
      });
    }        
  },
  mounted() {
    this.setDefaultSelection();
  },
  methods: {
    setDefaultSelection() {
      if (this.currentServeType != "")
      {
        this.$set(this.model.serveTypes, this.currentServeType, true);
      }
    },
    reset() {
      this.$emit("reset", true);
    },
    filter() {
      // console.log("model ", this.model);
      this.$emit("filterOnChange", this.model);
    }
  }
};
</script>
<style scoped>
.inline-label {
  position: relative;
  left: -210px;
}
</style>



// WEBPACK FOOTER //
// resources/js/sen-school/SenLeftSideBar.vue